$('.subscribe form').on('submit', function(event) {
  event.preventDefault();

  const $form = $(this);
  const formAction = $form.attr('action');

  $.ajax({
    url: formAction,
    type: 'post',
    dataType: 'jsonp',
    jsonp: 'c',
    data: $form.serialize()
  }).done(function(data) {
    let message = data.msg;
    message = message.toString().replace(/^\d+? ?-? ?/gm, '');

    if (data.result === 'error') {
      $form
        .addClass('error')
        .find('.subscribe__errors')
        .addClass('show')
        .html(`<p>${message}</p>`);
    } else {
      $form
        .addClass('submitted')
        .find('.subscribe__message')
        .html(`<p>${message}</p>`);
    }
  });
});



// WEBPACK FOOTER //
// ./../src/assets/js/subscribe.js